export default __webpack_public_path__ + "static/Net_Atlantic-74c9b27eb57a8ed94c36e2a0c25a84af.png";